
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import HorizontalLine from '@/components/atoms/HorizontalLine.vue'
import KatexText from '@/components/atoms/KatexText.vue'
import ModalWindow from '@/components/molecules/ModalWindow.vue'
import ButtonSubmit from '@/components/molecules/ButtonSubmit.vue'
import QuestionResultArea from '@/components/organisms/QuestionResultArea.vue'
import QuestionResultTip from '@/components/organisms/QuestionResultTip.vue'
import { StudyModel } from '@/models/StudyModel'

/**
 * 校正画面-正誤結果表示モーダル
 */
@Component({
  components: {
    HorizontalLine,
    KatexText,
    ModalWindow,
    ButtonSubmit,
    QuestionResultArea,
    QuestionResultTip,
  },
})
export default class ModalProofreadQuestion extends Vue {
  /** モーダル分子 */
  @Ref()
  modalWindow!: ModalWindow

  /** 確認ボタン押下時のイベント */
  @Prop()
  private eventSubmit!: () => void

  /** 設問情報 */
  question: StudyModel.Question | null = null

  /** 正答例 */
  correctAnswers: string[][] = []

  /** 正誤結果 */
  isCorrect: boolean = false

  /**
   * モーダルを開く
   *
   * @param question 設問情報
   * @param correctAnswers 正答(入力欄・許容解全ての二次元配列)
   * @param isCorrect 正誤結果
   */
  public show(question: StudyModel.Question, correctAnswers: string[][], isCorrect: boolean): void {
    this.question = question
    this.correctAnswers = correctAnswers
    this.isCorrect = isCorrect
    this.modalWindow.show()
  }

  /**
   * モーダルを閉じる
   */
  public hide(): void {
    this.modalWindow.hide()
  }
}
